import { IPhongUuTienNhom } from "../../../model/respone/category/IPhongUuTienNhom";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const ePhongUuTienNhomActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IPhongUuTienNhom[],
  LOAD_ERRR: "",

  SHOW_EDIT_MODAL: {} as IPhongUuTienNhom | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as IPhongUuTienNhom,
  SAVE_SUCCESS: undefined,
  SAVE_ERRR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERRR: "",
};

export const ePhongUuTienNhomActionIds = generateActionTypeIds(ePhongUuTienNhomActionsObj, "PHONG_UU_TIEN_NHOM");
export type IPhongUuTienNhomActionTypes = IGenericActionType<typeof ePhongUuTienNhomActionsObj, "PHONG_UU_TIEN_NHOM">;
